<template>
  <v-dialog v-model="dialog" width="400px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" depressed>
        <v-icon> mdi-send </v-icon>
      </v-btn>
    </template>
    <v-card tile>
      <v-card-title>Dispatch Job</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 pb-5">
        <p>Job Number: {{ item.job_number }}</p>
        <p>Job Type: {{ item.template_name }}</p>
        <v-form v-model="valid" ref="form">
          <v-autocomplete
            outlined
            :rules="rules"
            label="Technicians"
            item-text="name"
            item-value="phone"
            :items="list"
            v-model="technician"
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" @click="dialog = false" text>Cancel</v-btn>
        <v-btn color="success" @click="submit()" text>Send Text</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate } from "../../assets/js/common";
import { functions } from "../../assets/js/firebase";
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      valid: false,
      search: "",
      dialog: false,
      technician: "",
      message: "",
      rules: [(v) => !!v || "Field is required."],
      multiple: [(v) => v.length != 0 || "Field is required."],
    };
  },
  watch: {
    dialog() {
      this.init();
    },
  },
  computed: {
    list() {
      return this.$store.getters.technicians;
    },
  },
  methods: {
    onChange() {
      this.search = "";
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      let { technician } = vm;
      if (!vm.valid) return;
      let updated_at = getDate();
      try {
        vm.$root.loader = true;
        let { data } = await functions.httpsCallable("assignTechnician")({
          technician,
          id: vm.item.id,
          updated_at,
        });
        if (!data.status) {
          vm.$root.alert(data.message);
        } else {
          vm.dialog = false;
          vm.$emit("onDispatched");
        }
        vm.$root.loader = false;
      } catch (error) {
        console.log(error);
        vm.$alert.show(error.message);
        vm.$root.loader = false;
      }
    },
    init() {
      const vm = this;
      vm.technician = vm.item.technician;
      console.log(vm.technician);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
